<template>
  <div class="card card-user">
    <div class="image">
      <img :src="collaborator.banner_url" alt="..." />
    </div>
    <div class="card-content">
      <div class="author">
        <img class="avatar border-white" :src="collaborator.avatar_url" alt="..." />
        <h4 class="title">
          {{ collaborator.name }}
          <br />
          <a href="#" v-if="collaborator.position">
            <small>{{ collaborator.position.name }}</small>
          </a>
        </h4>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p class="description text-center" v-if="collaborator.position">
            <b class="seg" v-if="collaborator.position.department">{{ collaborator.position.department.company.name }}</b>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  props: {
    collaborator: [Object]
  },
  data () {
    return {}
  },
  filters: {
    formatDateBr (date) {
      return moment(date).format('DD/MM/YYYY')
    }
  },
  methods: {

  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Manager/Evaluation/Team/CollaboratorProfile/CollaboratorCard.vue